import {customFetch as fetch} from '../../../fetch';
import {errorToast, successToast} from '../../../toastr-helper';
import PayrollEmployeesStatusDenyIdPopup from './payrollEmployeesStatusDenyIdPopup'
import PayrollEmployeesStatusContractDetailsPopup from './payrollEmployeesStatusContractDetailsPopup'
import PayrollEmployeesStatusContractTypesPopup from './payrollEmployeesStatusContractTypesPopup'
import * as toastr from 'toastr';
import basicEmployeeStatus from "./basicEmployeeStatus";

class PayrollEmployeesStatusManager {
    
    static approveId = async (employeeId: string, reloadContracts: () => void) => {
        const fd = new FormData();
        fd.append('employeeId', employeeId);

        const response = await fetch(`/Admin/EmployeesRegistrationStatus/ApproveId`, {
            method: 'POST',
            body: fd
        });

        const warnings: string[] = response.data;

        if (response !== undefined) {
            const warnings: string[] = response.data.warnings;
            const errors: string[] = response.data.errors;

            if (warnings && warnings.length > 0) {
                warnings.forEach((w) => {
                    toastr.warning(w, 'Fout', {
                        timeOut: 0,
                        extendedTimeOut: 0
                    });
                });
            }

            if (response.ok) {
                successToast('De wijzigingen zijn opgeslagen');
                reloadContracts();
            }
        }
    }
    
    static openDenyIdPopup = (employeeId: string, reloadContracts: (selectedTab: number) => void) => {
        PayrollEmployeesStatusDenyIdPopup.resetValues();
        PayrollEmployeesStatusDenyIdPopup.updateEmployeeId(employeeId, reloadContracts);

        const target = document.getElementById('deny-id');
        if (target) {
            document.documentElement.classList.add('popup_open');
            target.classList.add('open');
            document.documentElement.querySelector('.backface')!.classList.add('open');
        }
    };
    
    static openContractDetailsPopup = async (item: basicEmployeeStatus) => {
        PayrollEmployeesStatusContractDetailsPopup.load(item);
        
        const target = document.getElementById('contractDetails-id');
        if (target) {
            document.documentElement.classList.add('popup_open');
            target.classList.add('open');
            document.documentElement.querySelector('.backface')!.classList.add('open');
        }
    };

    static openContractTypesPopup = async (employmentAgreementId: string, reloadContracts: (selectedTab: number) => void) => {
        //get all active employees with contractType. employmentAgreementId
        //make it changeable to all contracts per company and savable.
        PayrollEmployeesStatusContractTypesPopup.getAvailableContractTypes(employmentAgreementId, reloadContracts);
        
        const target = document.getElementById('contractType-id');
        if (target) {
            document.documentElement.classList.add('popup_open');
            target.classList.add('open');
            document.documentElement.querySelector('.backface')!.classList.add('open');
        }
    };

    static sendContract = async (item: any, reloadContracts: () => void) => {
        const fd = new FormData();
        fd.append('employmentAgreementId', item.employmentAgreementId);

        const response = await fetch(`/Admin/EmployeesRegistrationStatus/SendContract`, {
            method: 'POST',
            body: fd
        });

        if (response.ok) {
            successToast('Het contract is verzonden');
            reloadContracts();
        } else if (response.data) {
            errorToast(response.data);
        }
    };
    
    static resendContract = async (item: any, reloadContracts: () => void) => {
        const fd = new FormData();
        fd.append('employmentAgreementId', item.employmentAgreementId);

        const response = await fetch(`/Admin/EmployeesRegistrationStatus/ResendContract`, {
            method: 'POST',
            body: fd
        });

        if (response.ok) {
            successToast('Het contract is opnieuw verzonden');

            reloadContracts();
        } else if (response.errors && response.errors.length > 0) {
            const errors = response.errors.join('\n');
            errorToast(errors);
        } 
    };

    static resendInvite = async (item: any, reloadContracts: () => void) => {
        const fd = new FormData();
        fd.append('employmentAgreementId', item.employmentAgreementId);

        const response = await fetch(`/Admin/EmployeesRegistrationStatus/ResendInvite`, {
            method: 'POST',
            body: fd
        });

        if (response.ok) {
            successToast('De wijzigingen zijn opgeslagen');
        }
    };
    
    static sendEmployeesToAfas = async (employeeIds: string[], employmentAgreementId: string, onSuccess: () => void, onFail: () => void) => {
        const fd = new FormData();
        employeeIds.forEach((id) => fd.append('employeeIds[]', id));
        fd.append('employmentAgreementId', employmentAgreementId);

        const response = await fetch('/Admin/EmployeesRegistrationStatus/SendEmployees', {
            method: 'POST',
            body: fd
        });

        const warnings: string[] = response.data;
        
        if (response !== undefined) {
            const warnings: string[] = response.data.warnings;
            const errors: string[] = response.data.errors;

            if (warnings.length > 0) {
                warnings.forEach((w) => {
                    toastr.warning(w, 'Fout', {
                        timeOut: 0,
                        extendedTimeOut: 0
                    });
                });
                onFail();
            }

            if (errors.length > 0) {
                errors.forEach((e) => {
                    toastr.error(e, 'Fout', {
                        timeOut: 0,
                        extendedTimeOut: 0
                    });
                });
                onFail();
            }

            if (response.ok) {
                successToast('De wijzigingen zijn opgeslagen');
                onSuccess();
            }
        }
    };

    static placeEmployeesToAfas = async (employeeIds: string[], onSuccess: () => void, onFail: () => void) => {
        const fd = new FormData();
        employeeIds.forEach((id) => fd.append('employeeIds[]', id));

        const response = await fetch('/Admin/EmployeesRegistrationStatus/SendPlacements', {
            method: 'POST',
            body: fd
        });

        if (response.ok || response.status == 400) {
            const warnings: string[] = response.data;

            if (warnings !== undefined && warnings.length > 0) {
                warnings.forEach((w) => {
                    toastr.error(w, 'Fout', {
                        timeOut: 0,
                        extendedTimeOut: 0
                    });
                });
                onFail();
            } else {
                successToast('De wijzigingen zijn opgeslagen');
                onSuccess();
            }
        }
        else if(response.errors !== undefined) {
            response.errors.forEach((error) => {
                toastr.error(error.message, 'Fout', {
                    timeOut: 0,
                    extendedTimeOut: 0
                });
            });
            onFail();
        }
    }
}

export default PayrollEmployeesStatusManager;
